import React, { Component } from 'react';

import moment from 'moment';

import { Cell, ActionCell } from 'components/Table';
import Reactable, {Table, Thead, Th, Tr, Td} from 'reactable';
import { keyedObjToArr, formatAddress } from '../util';

import Button from 'components/Button';
import editIcon from '../../assets/icons/edit';
import trashIcon from '../../assets/icons/trash';


import 'sass/components/table.scss';

class CustomerCell extends Component {
	render () {
		return(<Cell {...this.props}>
						<div className="data normal-size bold">{this.props.item.name}</div>
						<div className="data small-caps light-text-color">{formatAddress(this.props.item.contactAddress)}</div>
					</Cell>);
	}

}

class ActivatedCell extends Component {

	// Data
	// Activated
	// active && date order was created

	render () {
		return(<Cell {...this.props}>
			<div className="data">{this.props.item.dateActivated ? moment(this.props.item.dateActived).format('MM/DD/YYYY') : (<span className="empty-cell"/>)}</div>
		</Cell>);
	}

}


export default class CustomerList extends Component {

	render () {
		let customers = keyedObjToArr(this.props.customers);

		//TODO if customer list is empty, render empty view

		return (
			<Table
				className="table ui-list"
				sortable={['customer','status','students']}
				filterable={['customer','status','students']}
				hideFilterInput
				filterBy={this.props.filterBy}
				noDataText=" No customers found"
				defaultSort={'customer'}
			>
				<Thead className="list-row header">
				<Th className="list-cell" column="customer">Customer</Th>
				<Th className="list-cell" column="products">Products</Th>
				{/*<Th className="list-cell" column="status" >Status</Th>*/}
				<Th className="list-cell" column="students">Students</Th>
				<Th className="list-cell align-center narrow" column="edit">Edit</Th>
				</Thead>
				{customers.map((customerItem, index) => {
                    let studentCount = this.props.getProductsForCustomer(customerItem).reduce( (studentCount, product)=> {
                        let test = Number(studentCount) + Number(product.studentCount);
                        return test;
                    }, 0);
                    let products = this.props.getProductsForCustomer(customerItem);
                    let status = customerItem.active ? 'Active' : '';
					return (
						<Tr className="list-row" key={index}>
							<Td className="list-cell" column="customer" value={customerItem.name}>
								<CustomerCell
									item={customerItem}
								/>
							</Td>
							<Td className="list-cell" column="products">
								<ul>
                                    {products.map( (product, index)=> {
                                        return(<li key={index} className="data">{product.name}</li>);
                                    })}
								</ul>
							</Td>
							{/*<Td className="list-cell" column="status">*/}
								{/*{status}*/}
							{/*</Td>*/}
							<Td className="list-cell" column="students">
								{studentCount}
							</Td>
							<Td className="list-cell align-center narrow" column="edit">
								<ActionCell
									item={customerItem}
									edit={this.props.editCustomer.bind(this)}
									delete={this.props.deleteCustomer.bind(this)}
								/>
							</Td>
						</Tr>
					);
				})}
			</Table>
		);
	}
}


// WEBPACK FOOTER //
// ./js/components/CustomerList.js